'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mergeOpts = require('merge-options');

var toMfsPath = require('./utils/to-mfs-path.js');

var debug = require('debug');

var errCode = require('err-code');

var ipfsUnixfs = require('ipfs-unixfs');

var toTrail = require('./utils/to-trail.js');

var addLink = require('./utils/add-link.js');

var updateTree = require('./utils/update-tree.js');

var updateMfsRoot = require('./utils/update-mfs-root.js');

var dagPB = require('@ipld/dag-pb');

var cid = require('multiformats/cid');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:touch');
var defaultOptions = {
  flush: true,
  shardSplitThreshold: 1000,
  cidVersion: 0,
  hashAlg: 'sha2-256'
};

function createTouch(context) {
  function mfsTouch(_x) {
    return _mfsTouch.apply(this, arguments);
  }

  function _mfsTouch() {
    _mfsTouch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          settings,
          _yield$toMfsPath$toMf,
          cid$1,
          mfsDirectory,
          name,
          exists,
          hashAlg,
          hasher,
          updatedBlock,
          updatedCid,
          cidVersion,
          metadata,
          hash,
          block,
          node,
          _metadata,
          _hash,
          trail,
          parent,
          parentCid,
          parentBlock,
          parentNode,
          result,
          newRootCid,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              settings = mergeOptions(defaultOptions, options);
              settings.mtime = settings.mtime || new Date();
              log("Touching ".concat(path, " mtime: ").concat(settings.mtime));
              _context.next = 6;
              return toMfsPath.toMfsPath(context, path, settings);

            case 6:
              _yield$toMfsPath$toMf = _context.sent;
              cid$1 = _yield$toMfsPath$toMf.cid;
              mfsDirectory = _yield$toMfsPath$toMf.mfsDirectory;
              name = _yield$toMfsPath$toMf.name;
              exists = _yield$toMfsPath$toMf.exists;
              hashAlg = options.hashAlg || defaultOptions.hashAlg;
              _context.next = 14;
              return context.hashers.getHasher(hashAlg);

            case 14:
              hasher = _context.sent;
              cidVersion = settings.cidVersion;

              if (exists) {
                _context.next = 28;
                break;
              }

              metadata = new ipfsUnixfs.UnixFS({
                type: 'file',
                mtime: settings.mtime
              });
              updatedBlock = dagPB__namespace.encode({
                Data: metadata.marshal(),
                Links: []
              });
              _context.next = 21;
              return hasher.digest(updatedBlock);

            case 21:
              hash = _context.sent;
              updatedCid = cid.CID.create(settings.cidVersion, dagPB__namespace.code, hash);

              if (!settings.flush) {
                _context.next = 26;
                break;
              }

              _context.next = 26;
              return context.repo.blocks.put(updatedCid, updatedBlock);

            case 26:
              _context.next = 47;
              break;

            case 28:
              if (!(cid$1.code !== dagPB__namespace.code)) {
                _context.next = 30;
                break;
              }

              throw errCode__default["default"](new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

            case 30:
              cidVersion = cid$1.version;
              _context.next = 33;
              return context.repo.blocks.get(cid$1);

            case 33:
              block = _context.sent;
              node = dagPB__namespace.decode(block);

              if (node.Data) {
                _context.next = 37;
                break;
              }

              throw errCode__default["default"](new Error("".concat(path, " had no data")), 'ERR_INVALID_NODE');

            case 37:
              _metadata = ipfsUnixfs.UnixFS.unmarshal(node.Data);
              _metadata.mtime = settings.mtime;
              updatedBlock = dagPB__namespace.encode({
                Data: _metadata.marshal(),
                Links: node.Links
              });
              _context.next = 42;
              return hasher.digest(updatedBlock);

            case 42:
              _hash = _context.sent;
              updatedCid = cid.CID.create(settings.cidVersion, dagPB__namespace.code, _hash);

              if (!settings.flush) {
                _context.next = 47;
                break;
              }

              _context.next = 47;
              return context.repo.blocks.put(updatedCid, updatedBlock);

            case 47:
              _context.next = 49;
              return toTrail.toTrail(context, mfsDirectory);

            case 49:
              trail = _context.sent;
              parent = trail[trail.length - 1];
              parentCid = parent.cid;
              _context.next = 54;
              return context.repo.blocks.get(parentCid);

            case 54:
              parentBlock = _context.sent;
              parentNode = dagPB__namespace.decode(parentBlock);
              _context.next = 58;
              return addLink.addLink(context, {
                parent: parentNode,
                name: name,
                cid: updatedCid,
                size: updatedBlock.length,
                flush: settings.flush,
                shardSplitThreshold: settings.shardSplitThreshold,
                hashAlg: settings.hashAlg,
                cidVersion: cidVersion
              });

            case 58:
              result = _context.sent;
              parent.cid = result.cid;
              _context.next = 62;
              return updateTree.updateTree(context, trail, settings);

            case 62:
              newRootCid = _context.sent;
              _context.next = 65;
              return updateMfsRoot.updateMfsRoot(context, newRootCid, settings);

            case 65:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _mfsTouch.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsTouch);
}

exports.createTouch = createTouch;